import Component from '@glimmer/component'
import { service } from '@ember/service'
import type SchoolRolloverService from 'district-ui-client/services/school-rollover'
import { AlertType, InlineAlert } from 'district-ui-client/components/inline-alert'
import { t } from 'ember-intl'
import type ExternalRosteringService from 'district-ui-client/services/external-rostering'
import { isPresent } from '@ember/utils'

interface Signature {
  Element: HTMLElement
}

export class RolloverAlert extends Component<Signature> {
  @service schoolRollover!: SchoolRolloverService
  @service externalRostering!: ExternalRosteringService

  get showRolloverAlert() {
    return isPresent(this.schoolRollover.schoolsInRollover) && !this.externalRostering.isEnabled
  }

  <template>
    {{#if this.showRolloverAlert}}
      <InlineAlert @type={{AlertType.Critical}} @showClose={{true}} ...attributes data-test-rollover-alert>
        <div class="space-y-2">
          <h2 class="m-0 text-sm font-medium">
            {{t "rollovers.modalTitle"}}
          </h2>
          <p class="m-0 text-sm">{{t "rollovers.alert"}}</p>
          <ul class="list-disc px-5 pt-1 text-sm font-bold">
            {{#each this.schoolRollover.schoolsInRollover as |school|}}
              <li>
                <span>{{school.name}}</span>
              </li>
            {{/each}}
          </ul>
        </div>
      </InlineAlert>
    {{/if}}
  </template>
}

export default RolloverAlert
